import { httpsCallable } from 'firebase/functions'
import { functions } from '@/services/firebaseconfig'
import { getInstanceByUid } from '@/utils/aiInstances'

export const isFleetPeer = uid => Boolean(getInstanceByUid(uid))

const messages = {
  'instance-offline': 'This AI is offline or its voice connection is not ready.',
  'instance-unavailable': 'Voice calls are not enabled for this AI yet.',
  'instance-busy': 'This AI is already on a voice call. Please try again shortly.',
  'human-unavailable': 'The recipient is unavailable for a walkie call.',
  'audience-changed': 'Your access changed during the call. Please start a new call.',
  'not-authorized': 'You no longer have access to this call.',
}

export async function fleetWalkieControl(operation, callId, args = {}) {
  try {
    const result = await httpsCallable(functions, 'fleetWalkieControl', { timeout: 15000 })({
      ...args,
      operation,
      ...(callId ? { callId } : {}),
    })
    return result.data
  } catch (error) {
    const message = messages[error.message]
    if (message) throw new Error(message)
    throw new Error('The AI voice connection is unavailable. Please try again shortly.')
  }
}
